/**
 * credential-challenge-server-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../../validation/decorators";
import { IncomingMessage } from "../../general/incoming-message";
import { MessageTag } from "../../message-tag";

/**
 * After a server successfully processes a {@link BeginPasswordResetRequest},
 * the server will respond to the client with a {@link
 * CredentialChallengeServerRequest} that contains the first prompt for which
 * the client must answer via a {@link CredentialChallengeClientResponse}.
 * These messages are exchanged until all prompts have been satisfied, or any
 * answer has been rejected.
 * Assuming that all prompts are satisfied, the server will send a {@link
 * NewPasswordServerRequest} to request a replacement password.
 */
@validateFor(MessageTag.SREQ_CREDENTIAL_CHALLENGE)
export class CredentialChallengeServerRequest extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.SREQ_CREDENTIAL_CHALLENGE;
	public static tag : MessageTag = MessageTag.SREQ_CREDENTIAL_CHALLENGE;

  @validateAs("string")
  public prompt : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/credential-challenge-server-request.ts